function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
export default function generateId(config) {
    var _window;
    // The id is calculated by using the parameters that re-renders the hubs
    // service, project, release, page, userId, and the ones that are included in the ErrorPropsToMemoize type
    const { service, project, release, page, userId, errors } = config;
    // This destructuration removes the readonly conditions at the type level for comparation
    const memoizableErrorsConfig = _object_spread({}, errors);
    var _memoizableErrorsConfig_tags, _memoizableErrorsConfig_extras, _memoizableErrorsConfig_whitelistUrls, _memoizableErrorsConfig_expectedJsErrors;
    const hash = [
        service,
        project,
        release,
        page,
        userId,
        JSON.stringify((_memoizableErrorsConfig_tags = memoizableErrorsConfig === null || memoizableErrorsConfig === void 0 ? void 0 : memoizableErrorsConfig.tags) !== null && _memoizableErrorsConfig_tags !== void 0 ? _memoizableErrorsConfig_tags : {}),
        JSON.stringify((_memoizableErrorsConfig_extras = memoizableErrorsConfig === null || memoizableErrorsConfig === void 0 ? void 0 : memoizableErrorsConfig.extras) !== null && _memoizableErrorsConfig_extras !== void 0 ? _memoizableErrorsConfig_extras : {}),
        memoizableErrorsConfig === null || memoizableErrorsConfig === void 0 ? void 0 : memoizableErrorsConfig.captureUnhandledErrors,
        JSON.stringify((_memoizableErrorsConfig_whitelistUrls = memoizableErrorsConfig === null || memoizableErrorsConfig === void 0 ? void 0 : memoizableErrorsConfig.whitelistUrls) !== null && _memoizableErrorsConfig_whitelistUrls !== void 0 ? _memoizableErrorsConfig_whitelistUrls : []),
        JSON.stringify((_memoizableErrorsConfig_expectedJsErrors = memoizableErrorsConfig === null || memoizableErrorsConfig === void 0 ? void 0 : memoizableErrorsConfig.expectedJsErrors) !== null && _memoizableErrorsConfig_expectedJsErrors !== void 0 ? _memoizableErrorsConfig_expectedJsErrors : []),
        memoizableErrorsConfig === null || memoizableErrorsConfig === void 0 ? void 0 : memoizableErrorsConfig.disabled
    ].join('|');
    if (typeof window !== 'undefined' && ((_window = window) === null || _window === void 0 ? void 0 : _window.btoa)) {
        var _window1;
        return (_window1 = window) === null || _window1 === void 0 ? void 0 : _window1.btoa(hash);
    }
    return hash;
}

//# sourceMappingURL=generateId.js.map